import {
  AnalyticsEvent,
  ShoppingEvents,
  useAnalytics,
} from '@storefront-core/analytics-web';
import { Product } from '../types/model.types';
import { CartItem } from '../types/cart.types';
import { getPageNameFromCookies } from '../utlis/analytics.util';

export const useAnalyticsEvents = () => {
  const { trackEvent } = useAnalytics();
  const currency = "MYR"
  const trackCarouselImpression = (title:string, sourceEvent:string, recommendationType?:string, productIds: string[]= [],isFromBasket:boolean = false) => {
    const impressionAnalytics = {
        currency : currency,
        carouselName: title,
        sourceEvent,
        getPersonalizedRecommendationsFromDb: recommendationType,
        products: productIds
    };
    const properties = {
      pageName: isFromBasket ? "basket" : getPageNameFromCookies(),
      ...impressionAnalytics,
    };
    trackEvent(ShoppingEvents.productCarouselImpression, properties);
  };

  const trackCarouselScroll = (title:string, sourceEvent:string, recommendationType?:string, isFromBasket:boolean = false) => {
    const impressionAnalytics = {
        currency : currency,
        carouselName: title,
        sourceEvent,
        getPersonalizedRecommendationsFromDb: recommendationType
    };
    const properties = {
      pageName: isFromBasket ? "basket" : getPageNameFromCookies(),
      ...impressionAnalytics,
    };
    trackEvent(ShoppingEvents.productCarouselSlide, properties);
  };

  const trackCarouselSeeAll = (title:string, eventName: ("carouselHeaderViewAllClick" | "carouselListViewAllClick"), sourceEvent:string, recommendationType?:string, isFromBasket:boolean = false) => {
    const impressionAnalytics = {
        currency : currency,
        carouselName: title,
        sourceEvent,
        getPersonalizedRecommendationsFromDb: recommendationType
    };
    const properties = {
      pageName: isFromBasket ? "basket" : getPageNameFromCookies(),
      ...impressionAnalytics,
    };
    trackEvent(eventName, properties);
  };

  const trackPdpClick = (product:Product,indexClicked:number, carouselName:string, sourceEvent:string, recommendationType?:string, isFromBasket:boolean = false) => {
    const unitPrice = product.originalPrice ?? product.price ?? 0;
    const displayPrice = product.price ?? product.originalPrice ?? 0;
    const pdpClickAnalytics = {
        productId : product.id,
        sku: product.sku ?? '',
        unitPrice,
        displayPrice,
        currency : currency,
        indexClicked,
        sourceEvent,
        position: indexClicked,
        getPersonalizedRecommendationsFromDb: recommendationType
    };
    const properties = {
      pageName: isFromBasket ? "basket" : getPageNameFromCookies(),
      ...pdpClickAnalytics,
      carouselName
    };
    trackEvent(ShoppingEvents.productCarouselItemClick, properties);
  };

  const normalizeCartItems = (cartItems: CartItem[] | Record<string, CartItem>): CartItem[] => {
    if (Array.isArray(cartItems)) return cartItems;
    if (cartItems && typeof cartItems === "object") return Object.values(cartItems);
    return [];
  };

  const trackAddToBasket = (product:Product, productIndex:number, title:string, quantity:number, cartItems: CartItem[], sourceEvent:string, recommendationType?:string, isFromBasket:boolean = false) => {
    if (!product?.id) return;
    const productId = product.id;
    const normalizedQuantity = typeof quantity === "number" && !Number.isNaN(quantity) ? quantity : 0;
    const validCartItems = normalizeCartItems(cartItems);
    const unitPrice = product.originalPrice ?? product?.price ?? 0;
    const displayPrice = product.price ?? product?.originalPrice ?? 0;
    const existingItem = validCartItems.find((item) => item?.productId === product.id);

    const isNewItem = !existingItem;
    const previousQty = existingItem
                        ? existingItem.type === "weight"
                          ? (existingItem.weight ?? 0)
                          : (existingItem.quantity ?? 0)
                        : 0;
    const isRemove = normalizedQuantity === 0;
    const analyticsEventType =
      isRemove
        ? AnalyticsEvent.productUpdateBasketItem
        : isNewItem
        ? AnalyticsEvent.productAddToBasket
        : AnalyticsEvent.productUpdateBasketItem;

    const resolvedsourceEvent =
      isRemove ? 'deleteItem'
      : isNewItem || normalizedQuantity > previousQty ? (isNewItem ? sourceEvent: 'increaseItem')
      : 'decreaseItem';
    const indexClicked = productIndex;
    const carouselName = title
    const analyticsEvents = {
      productId,
      sku: product?.sku ?? '',
      unitPrice,
      displayPrice,
      currency: currency,
      quantity: normalizedQuantity,
      sourceEvent: resolvedsourceEvent,
      value : normalizedQuantity * displayPrice,
      indexClicked,
      carouselName,
      getPersonalizedRecommendationsFromDb: recommendationType
    };
    const properties = {
      pageName: isFromBasket ? "basket" : getPageNameFromCookies(),
      ...analyticsEvents,
    };
    trackEvent(analyticsEventType, properties);
  };

  return {
    trackPdpClick,
    trackAddToBasket,
    trackCarouselImpression,
    trackCarouselScroll,
    trackCarouselSeeAll
  };
};
